import header from './header';
import navMenu from './navMenu';
import profile from './profile';
import repos from './repos';

export default {
    header,
    navMenu,
    profile,
    repos
};



// WEBPACK FOOTER //
// ./src/vuex/modules/index.js